import { useIsDesktop } from '@cian/valuation-utils-component';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { WarningBanner } from '../../components/AboutHome/components/WarningBanner';
import { selectHouseInfo } from '../../selectors/houseInfo';
import { getWarningIfno } from './utils';

export const WarningContainer: React.FC = () => {
  const isDesktop = useIsDesktop();
  const houseInfo = useSelector(selectHouseInfo);

  if (!houseInfo.data) {
    return null;
  }

  const { isEmergency, isRenovation, isCulturalHeritage } = houseInfo.data;
  const warningInfo = getWarningIfno({ isEmergency, isRenovation, isCulturalHeritage });

  if (!warningInfo) {
    return null;
  }

  return <WarningBanner isDesktop={isDesktop} {...warningInfo} />;
};

WarningContainer.displayName = 'WarningContainer';
